import React from "react";
const Section6 = () => {

    return (
        <div className="bg-[#EAF4FF] relative px-40 py-16 flex flex-col items-center text-center">
            <h2 className="text-[#033d8e] text-4xl font-bold">Tu seguridad es nuestra prioridad</h2>
            <p className="text-[#2f6fe8] max-w-2xl text-xl font-bold mt-4">
                Comparte tus datos solo con entidades que cuenten con una <span className="text-[#033d8e]">Política de Terceros Receptores de Datos (TRD)</span>. Conoce la nuestra aquí:
            </p>

            <div className="flex gap-6 mt-6">
                <button className="bg-[#033d8e] text-white text-lg font-bold px-10 py-3 rounded-full shadow-lg">
                    Ver más entidades
                </button>
                <button className="bg-[#033d8e] text-white text-lg font-bold px-10 py-3 rounded-full shadow-lg">
                    Ver menos entidades
                </button>
            </div>

            <p className="text-[#033d8e] text-lg font-bold mt-4  cursor-pointer">
                Política de Terceros Receptores de Datos aquí
            </p>
        </div>



    );
};

export default Section6;
